import {
    getTrimList,
    getTrim,
} from "../apis/api_trim.js";

import { listMode } from '../utils/table';

const state = {
    filters: { mode: listMode.list, status:'20' },
    items: [],
    item: {
        atts:[],
    },    
};

const getters = {
};

const mutations = {
    SET_TRIM_LIST(state, items){
        state.items = items;
    },

    SET_TRIM(state, payload) {
        state.item = payload
    },

    CLEAR_TRIM(state) {
        state.item = {
            atts:[],
        };
    },
    CLEAR_TRIM_LIST(state) {
        state.items = [];
    },
};

const actions = {

    async GET_TRIM_LIST({ state, commit }, params) {
        let filters = { ...state.filters, ...params };
        try {
            const response = await getTrimList(filters);
            commit('SET_TRIM_LIST', response.data.data.content)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_TRIM({ commit }, id) {
        try {
            const response = await getTrim(id);
            commit('SET_TRIM', response.data.data)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },    
};

export default {mutations, state, actions, getters};